export function DiscordIcon({ size = 18 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" fill="currentColor">
      <path d="M19.54 5.34A16.3 16.3 0 0 0 15.5 4.1l-.5 1a15.2 15.2 0 0 0-6 0l-.52-1A16.2 16.2 0 0 0 4.45 5.35C1.9 9.1 1.2 12.77 1.55 16.4a16.6 16.6 0 0 0 4.95 2.5l1.2-1.62c-.66-.24-1.3-.55-1.89-.91l.46-.35c3.64 1.68 7.62 1.68 11.22 0l.47.35c-.6.36-1.24.67-1.9.91l1.2 1.62a16.5 16.5 0 0 0 4.95-2.5c.42-4.2-.72-7.83-2.67-11.06ZM8.4 14.18c-1.07 0-1.95-.98-1.95-2.18s.86-2.18 1.95-2.18c1.1 0 1.97.99 1.95 2.18 0 1.2-.86 2.18-1.95 2.18Zm7.2 0c-1.08 0-1.95-.98-1.95-2.18s.85-2.18 1.95-2.18c1.1 0 1.97.99 1.95 2.18 0 1.2-.85 2.18-1.95 2.18Z" />
    </svg>
  );
}

export function ArrowIcon() {
  return <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14M13 6l6 6-6 6" /></svg>;
}

export function CopyIcon() {
  return <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>;
}

export function CheckIcon() {
  return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 6L9 17l-5-5"/></svg>;
}

export function ShieldIcon() {
  return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>;
}

export function SparkIcon() {
  return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2l2.4 7.2L22 12l-7.6 2.8L12 22l-2.4-7.2L2 12l7.6-2.8L12 2z"/></svg>;
}
